/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Utils
import { v4 as uuid } from 'uuid';
import { uniq } from 'lodash';

// Components
import FilePicker from 'shared/ui/components/form-components/pickers/FilePicker.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import LanguagePickerModal from 'shared/ui/components/modals/LanguagePickerModal.vue';
import workerStarter from 'shared/ui/components/uploader/worker-starter';
import { nowUnixTimestamp } from 'libs/utils/time';

const getAttachmentName = (lang, timestamp) => `${uuid()}_${timestamp}_${lang}.vtt`;

const __vue_script__ = {
    name: 'VttPicker',

    components: { FilePicker, LanguagePickerModal },

    extends: BaseControl,

    mixins: [workerStarter],

    props: {
        event: {
            type: Object,
            default: () => {}
        },

        languages: {
            type: Array,
            default: () => []
        },

        scope: {
            type: String,
            required: true
        },

        uploadedSubtitleFiles: {
            type: Array,
            default: () => []
        },

        onSubmitHook: {
            type: Function,
            required: true
        }
    },

    data() {
        const existingLanguages = this.uploadedSubtitleFiles.map(file => file.lang);
        const langs = uniq([...existingLanguages, ...this.languages]);
        if (!langs.length) {
            langs.push('en');
        }
        const allLang = this.$utils.locales.getAllLanguages();

        const filesByLang = {};
        for (const lang of langs) {
            filesByLang[lang] = this.uploadedSubtitleFiles
                .filter(file => file.lang === lang)
                .map(file => ({ ...file, name: file.original_file_name }));
        }

        // Instruction for the lambda to delete the corresponding language's captions from the video
        const deletionContent = 'DELETE_ME';
        const deletionBlob = new Blob([deletionContent], { type: 'text/vtt' });
        // Arbitrary file name, that could be anything, as long as it has the .vtt extension
        const deletionFile = new File([deletionBlob], 'fake_file_with_command_for_lambda.vtt', { type: 'text/vtt' });

        return {
            title: this.$i18n.t('contents.closed_captions.title'),
            captionsPickerExtensions: ['vtt'],
            langs,
            allLang,
            filesByLang,
            deletionFile,
            existingLanguages,
            submitTimestamp: 0
        };
    },

    computed: {
        labelsByLang() {
            const labels = {};
            for (const lang of this.langs) {
                labels[lang] = this.allLang[lang].englishName;
            }
            return labels;
        },

        fileListToUpload() {
            const filesArray = [];
            const paramsArray = [];
            for (const lang in this.filesByLang) {
                const files = this.filesByLang[lang];
                const file = files?.[0];
                if (!file?.file) {
                    continue;
                }
                paramsArray.push({ attachmentName: getAttachmentName(lang, this.submitTimestamp) });
                filesArray.push(file);
            }

            return { filesArray, paramsArray };
        },

        fileListToDelete() {
            const filesArray = [];
            const paramsArray = [];

            for (const lang of this.existingLanguages) {
                if (!this.filesByLang[lang]?.[0]?.name) {
                    paramsArray.push({
                        attachmentName: getAttachmentName(lang, this.submitTimestamp),
                        hideInUploader: true
                    });
                    filesArray.push(this.deletionFile);
                }
            }

            return { filesArray, paramsArray };
        }
    },

    created() {
        this.initWorker();
    },

    methods: {
        onSubmit() {
            this.submitTimestamp = nowUnixTimestamp();

            const filesArray = [
                ...this.fileListToUpload.filesArray,
                ...this.fileListToDelete.filesArray
            ];

            const paramsArray = [
                ...this.fileListToUpload.paramsArray,
                ...this.fileListToDelete.paramsArray
            ];

            const dataTransfer = new DataTransfer();
            filesArray.forEach(file => dataTransfer.items.add(file.file || file));
            const fileList = dataTransfer.files;

            if (fileList.length) {
                console.log('[VttPicker] Start upload...', fileList);
                this.startUpload(fileList, {}, paramsArray);
            }

            const filenames = paramsArray.map(({ attachmentName }) => attachmentName);

            this.onSubmitHook(filenames);
            this.$emit('close');
        },

        addLanguages() {
            this.$modal.show(LanguagePickerModal, {
                languages: this.langs,
                title: this.$i18n.t('contents.closed_captions.add_language'),
                update: (data) => this.onLanguageChange(data)
            }, {
                clickToClose: false,
                height: 'auto'
            });
        },

        onReplaceFile(lang) {
            const uploaderRef = this.$refs[`uploader_${lang}`]?.[0];
            const inputRef = uploaderRef?.$refs?.input;

            if (inputRef) {
                inputRef.click();
            }
        },

        hasUploadedFile(lang) {
            return !!this.filesByLang[lang]?.[0]?.name;
        },

        onLanguageChange(data) {
            for (let lang in this.filesByLang) {
                if (!data.includes(lang)) {
                    delete this.filesByLang[lang];
                }
            }

            this.langs = data;
        },

        deleteFile(lang) {
            this.filesByLang[lang] = null;
            delete this.filesByLang[lang];
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-wrapper vtt-picker" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c("span", {
        staticClass: "close",
        on: {
          click: function () {
            return _vm.$emit("close")
          },
        },
      }),
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _c("div", { staticClass: "control-hint" }, [
        _vm._v(_vm._s(_vm.$t("contents.closed_captions.hint"))),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "modal-body" },
      _vm._l(_vm.langs, function (lang) {
        return _c("validation-provider", {
          key: lang,
          attrs: { slim: true, name: "closed_captions" },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function (ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "control-decorator",
                      {
                        staticClass: "vtt-item",
                        attrs: {
                          dependant: _vm.dependant,
                          label: _vm.labelsByLang[lang],
                          name: "closed_captions_" + lang,
                          errors: errors,
                          uid: _vm.uid,
                          tip: _vm.tip,
                          warning: _vm.warning,
                        },
                      },
                      [
                        _vm.hasUploadedFile(lang)
                          ? _c("i", {
                              staticClass: "ic-trash-2",
                              on: {
                                click: function () {
                                  return _vm.deleteFile(lang)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm.hasUploadedFile(lang)
                          ? _c("div", { staticClass: "files-uploaded" }, [
                              _c("div", { staticClass: "file-selected" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.onReplaceFile(lang)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.filesByLang[lang][0].name)
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _c("file-picker", {
                          ref: "uploader_" + lang,
                          refInFor: true,
                          attrs: {
                            name: "closed_captions_" + lang,
                            extensions: _vm.captionsPickerExtensions,
                            multiple: false,
                            size: Math.pow(1024, 2),
                            "always-replace": true,
                          },
                          on: {
                            removed: function (file) {
                              return _vm.$emit("removed", file)
                            },
                          },
                          model: {
                            value: _vm.filesByLang[lang],
                            callback: function ($$v) {
                              _vm.$set(_vm.filesByLang, lang, $$v)
                            },
                            expression: "filesByLang[lang]",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ],
            null,
            true
          ),
        })
      }),
      1
    ),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn add-languages-btn",
          on: { click: _vm.addLanguages },
        },
        [_vm._v(_vm._s(_vm.$t("contents.closed_captions.edit_language")))]
      ),
      _c("div", { staticClass: "buttons-submit-actions" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            on: {
              click: function () {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("general.cancel")))]
        ),
        _c(
          "button",
          { staticClass: "btn btn-primary", on: { click: _vm.onSubmit } },
          [_vm._v(_vm._s(_vm.$t("general.save")))]
        ),
      ]),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/pickers/VttPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__